import { IComponentController, IRootScopeService, resource } from "angular";

((angular): void => {
  interface Filters {
    page: number;
    private: true;
    order?: OrderField;
    sort?: "asc" | "desc";
  }

  enum OrderField {
    LastActiveAt = "last_activity_at",
    TotalReplies = "total_replies",
  }

  interface OrderFilter {
    label: string;
    params: {
      order: OrderField;
      sort: "asc" | "desc";
    };
  }

  enum OrderKey {
    LatestFirst = "latest-first",
    MostDiscussed = "most-discussed",
  }

  type OrderList = {
    readonly [key in OrderKey]: OrderFilter;
  };

  const SELECTABLE_ORDERS: OrderList = {
    "latest-first": {
      label: "Latest First",
      params: {
        order: OrderField.LastActiveAt,
        sort: "desc",
      },
    },

    "most-discussed": {
      label: "Most Discussed",
      params: {
        order: OrderField.TotalReplies,
        sort: "desc",
      },
    },
  };

  class Controller implements IComponentController {
    /**
     * The filters applied to the threads.
     * @type {Filters}
     * @memberof Controller
     */
    public filters: Filters = {
      page: 1,
      private: true,
    };

    /**
     * Whether the controller is currently loading data.
     * @memberof Controller
     */
    public isLoading = true;

    /**
     * The currently selected thread order.
     * @type {OrderKey}
     * @memberof Controller
     */
    public order: OrderKey = OrderKey.LatestFirst;

    /**
     * The thread data struture.
     * @memberof Controller
     */
    public threads: any;

    /**
     * @param {IRootScopeService} $rootScope
     * @param {resource.IResourceClass<any>} ForumThreadsApi
     * @memberof Controller
     */
    public constructor(
      protected $rootScope: IRootScopeService,
      protected ForumThreadsApi: resource.IResourceClass<any>,
    ) {
      this.fetchThreads = this.fetchThreads.bind(this);
      this.orderThreads = this.orderThreads.bind(this);

      $rootScope.$on("forum:updateThreads", this.fetchThreads);
    }

    /**
     * Do things on init.
     *
     * @memberof Controller
     */
    $onInit(): void {
      this.fetchThreads();
    }

    /**
     * Get the options for the order select element.
     * @returns {OrderList}
     * @memberof Controller
     */
    public getSelectableOrders(): OrderList {
      return SELECTABLE_ORDERS;
    }

    /**
     * Fetch threads from the API.
     * @memberof Controller
     */
    public fetchThreads(): void {
      const offset = $(".content-container.main").offset().top;

      window.scrollTo({ top: offset });
      this.isLoading = true;

      this.ForumThreadsApi.get(
        this.filters,
        (response: any) => {
          this.threads = response;
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        },
      );
    }

    /**
     * Called when the user changes thread order.
     * @memberof Controller
     */
    public orderThreads(): void {
      const order = SELECTABLE_ORDERS[this.order];
      this.filters = { ...this.filters, ...order.params };
      this.fetchThreads();
    }
  }

  Controller.$inject = ["$rootScope", "ForumThreadsApi"];

  angular.module("app").controller("forumPrivateThreadsController", Controller);
})(angular);
